import React, { useState } from "react";
import { Form } from "react-bootstrap";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

// Campo controlado del formulario de cuentas. El estado vive en el padre
// para poder contar los campos faltantes y validar en vivo.
const CredentialField = ({ field, value, error, onChange, disabled }) => {
  const [showSecret, setShowSecret] = useState(false);

  const isMultiline = Boolean(field.multiline);
  const isSecret = Boolean(field.secret);
  const inputType = isSecret && !showSecret ? "password" : "text";
  const styleInput = { borderColor: error ? "#d9534f" : "#899AF1", color: "#000" };

  const control = isMultiline ? (
    <Form.Control
      as="textarea"
      rows={6}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(field.key, event.target.value)}
      placeholder={field.placeholder}
      style={{ ...styleInput, fontFamily: "ui-monospace, Menlo, monospace", fontSize: 12.5 }}
    />
  ) : (
    <Form.Control
      type={inputType}
      value={value}
      disabled={disabled}
      onChange={(event) => onChange(field.key, event.target.value)}
      placeholder={field.placeholder}
      style={{
        ...styleInput,
        fontFamily: isSecret || field.validate === "guid" ? "ui-monospace, Menlo, monospace" : undefined,
        paddingRight: isSecret ? 44 : undefined,
      }}
    />
  );

  return (
    <Form.Group className="form-group" controlId={`cco-${field.key}`}>
      <Form.Label className="cco-label">
        {field.label}
        {field.required && <span className="cco-required">*</span>}
      </Form.Label>

      {isSecret && !isMultiline ? (
        <div className="cco-secret-wrap">
          {control}
          <button
            type="button"
            className="cco-eye"
            onClick={() => setShowSecret(!showSecret)}
            aria-label={showSecret ? `Hide ${field.label}` : `Show ${field.label}`}
            title={showSecret ? `Hide ${field.label}` : `Show ${field.label}`}
          >
            {showSecret ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
          </button>
        </div>
      ) : (
        control
      )}

      {error ? <div className="cco-hint cco-hint-error">{error}</div> : null}
    </Form.Group>
  );
};

export default CredentialField;
